import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import ru from './locales/ru.json'
import de from './locales/de.json'
import es from './locales/es.json'
import zh from './locales/zh.json'
import ko from './locales/ko.json'
import tr from './locales/tr.json'
import ptBR from './locales/pt-BR.json'
import ja from './locales/ja.json'

export const SUPPORTED_LOCALES = ['en', 'ru', 'de', 'es', 'zh', 'ko', 'tr', 'pt-BR', 'ja']
export const DEFAULT_LOCALE = 'en'
const LOCALE_STORAGE_KEY = 'avacapo-locale'
const LOCALE_SYNC_STORAGE_KEY = 'avacapo-locale-needs-sync'

function getInitialLocale() {
  const savedLocale = localStorage.getItem(LOCALE_STORAGE_KEY)
  if (SUPPORTED_LOCALES.includes(savedLocale)) return savedLocale

  const browserLocale = navigator.language.split('-')[0]
  return SUPPORTED_LOCALES.includes(browserLocale) ? browserLocale : DEFAULT_LOCALE
}

const i18n = createI18n({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages: { en, ru, de, es, zh, ko, tr, 'pt-BR': ptBR, ja },
})

export function getLocale() {
  return i18n.global.locale.value
}

export function hasPendingLocaleSync() {
  return localStorage.getItem(LOCALE_SYNC_STORAGE_KEY) === 'true'
}

export function setLocale(locale, { needsSync = true } = {}) {
  if (!SUPPORTED_LOCALES.includes(locale)) {
    throw new Error(`Unsupported locale: ${locale}`)
  }

  i18n.global.locale.value = locale
  localStorage.setItem(LOCALE_STORAGE_KEY, locale)
  if (needsSync) {
    localStorage.setItem(LOCALE_SYNC_STORAGE_KEY, 'true')
  }
  document.documentElement.lang = locale
}

export function setLocaleFromServer(locale) {
  if (!SUPPORTED_LOCALES.includes(locale)) return

  setLocale(locale, { needsSync: false })
}

export function markLocaleSynced() {
  localStorage.removeItem(LOCALE_SYNC_STORAGE_KEY)
}

export default i18n
